// authService.ts
import { auth } from "./../firebase/firebaseConfig";
import { GoogleAuthProvider, signInWithPopup, signOut, User, getAuth, signInAnonymously } from "firebase/auth";

// Google Sign-In Function
export const signInWithGoogle = async (): Promise<User> => {
  const provider = new GoogleAuthProvider();
  try {
    const result = await signInWithPopup(auth, provider);
    return result.user;
  } catch (error: any) {
    console.error("Google Sign-In error:", error);
    throw new Error(error.message);
  }
};

export const anonymousLogin=async():Promise<any>=>{
  try {
    const fbAuth = getAuth();
    const result = await signInAnonymously(fbAuth);
    return result.user;
  } catch (error: any) {
    console.error("Google Sign-In error:", error);
    throw new Error(error.message);
  }
}

export const signoutWithGoogle=async ()=>{
  try {
    console.log('SIGNING OUT...');
    await signOut(auth);
    return true;
  } catch (error:any) {
    console.error("Google Sign-out error:",error);
    throw new Error(error.message);
  }
}